var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-ueditor-wrap',{ref:"ueditor",attrs:{"config":_vm.myConfig},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})}
var staticRenderFns = []

export { render, staticRenderFns }